import { instance, objectToParams } from './api';

export const postSellsFile = (file) => {
  return instance.post(`/api/v1/sells/files/eph`, file);
};

export const getSells = (args) => instance.get(`/api/v1/sells?${objectToParams(args)}`);

export const postSell = (form) => instance.post(`/api/v1/sells`, form);

export const getSellById = (id) => instance.get(`/api/v1/sells/${id}`);

export const getSellsStockById = (id, args) => instance.get(`/api/v1/sells/${id}/stock?${objectToParams(args)}`);

export const postSellsStockById = (id, form) => instance.post(`/api/v1/sells/${id}/stock`, form);

export const postInvoice = (id) => instance.post(`/api/v1/sells/${id}/invoice`, {});

export const deleteSellById = (id) => instance.delete(`/api/v1/sells/${id}`);
